import { useEffect } from 'react'

/**
 * Elfsight Google Reviews widget
 * App ID: 7aa3c2c7-ca3e-4e75-ab64-8ab0add954ed
 */
export default function ElfsightGoogleReviews({ className = '' }) {
  useEffect(() => {
    const scriptSrc = 'https://elfsightcdn.com/platform.js'
    const existing = document.querySelector(`script[src="${scriptSrc}"]`)

    if (!existing) {
      const script = document.createElement('script')
      script.src = scriptSrc
      script.async = true
      document.body.appendChild(script)
    }

    return () => {
      // Intentionally keep the script cached for page navigation
    }
  }, [])

  return (
    <div className={className}>
      <div
        className="elfsight-app-7aa3c2c7-ca3e-4e75-ab64-8ab0add954ed"
        data-elfsight-app-lazy
      />
    </div>
  )
}
